import { BaasicPlatform } from 'baasic-sdk-reactjs';
import { baasicOptions } from 'common/infrastructure';

const platform = new BaasicPlatform(baasicOptions);

export default platform;



// WEBPACK FOOTER //
// ./src/common/infrastructure/platform.js